import React from "react";
import {UserFormTemplate} from "./UserFormTemplate";

export function UserFormCreate () {
    return (
        <UserFormTemplate/>
    )
}